var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 185,
    viewBox: "0 0 300 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_549_63577)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_549_63577)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 185,
    rx: 16,
    fill: "black",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 185,
    rx: 16,
    fill: "url(#paint0_radial_549_63577)",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_d_549_63577)",
    transform: "scale(0.85) translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_diamond_549_63577_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.109827 -0.000449647 0.000570935 0.328672 31.7827 136.218)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 477.054,
    height: 239.043,
    fill: "url(#paint1_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 477.054,
    height: 239.043,
    transform: "scale(1 -1)",
    fill: "url(#paint1_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 477.054,
    height: 239.043,
    transform: "scale(-1 1)",
    fill: "url(#paint1_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 477.054,
    height: 239.043,
    transform: "scale(-1)",
    fill: "url(#paint1_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M53.9223 208.937C40.2473 210.784 28.5469 207.93 17.9703 199.296C-9.52678 176.875 -29.3776 149.345 -1.4499 117.293C15.5966 97.737 37.7896 80.3524 55.2142 60.859L57.1993 59.9567L81.9341 85.3254L24.9758 143.596C20.1549 159.06 43.7134 179.551 57.1993 166.467L81.9341 191.081C76.3674 199.684 64.0893 207.574 53.9223 208.937Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":219.65402221679688,\"m01\":1.1418701410293579,\"m02\":-78.615242004394531,\"m10\":-0.89929437637329102,\"m11\":657.3430175781250,\"m12\":-192.00404357910156},\"opacity\":0.50,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint2_diamond_549_63577_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.170555 -0.000289537 0.000886655 0.211645 57.6179 58.0921)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 470.244,
    height: 242.578,
    fill: "url(#paint2_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 470.244,
    height: 242.578,
    transform: "scale(1 -1)",
    fill: "url(#paint2_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 470.244,
    height: 242.578,
    transform: "scale(-1 1)",
    fill: "url(#paint2_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 470.244,
    height: 242.578,
    transform: "scale(-1)",
    fill: "url(#paint2_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M110.894 105.254L57.8773 52.6853C42.2645 36.944 13.8862 64.6089 28.3958 80.664L3.78938 105.254C-17.3184 89.157 -21.4895 61.9 -4.11158 41.2323C14.8213 18.7133 39.4067 -2.35178 69.7603 15.9416L135.5 79.9214L110.904 105.264L110.894 105.254Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":341.10971069335938,\"m01\":1.7733093500137329,\"m02\":-113.82363891601562,\"m10\":-0.57907366752624512,\"m11\":423.28900146484375,\"m12\":-153.26287841796875},\"opacity\":0.50,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint3_diamond_549_63577_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.109827 -0.000449647 0.000570935 0.328672 135.502 85.2461)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 477.054,
    height: 239.043,
    fill: "url(#paint3_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 477.054,
    height: 239.043,
    transform: "scale(1 -1)",
    fill: "url(#paint3_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 477.054,
    height: 239.043,
    transform: "scale(-1 1)",
    fill: "url(#paint3_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 477.054,
    height: 239.043,
    transform: "scale(-1)",
    fill: "url(#paint3_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M114.465 158.502L89.878 133.117C96.9885 126.59 103.059 119.005 109.718 112.09C118.782 102.672 135.167 90.0476 142.267 80.8072C147.781 73.6307 148.652 66.9256 142.844 59.4348C136.112 50.7497 124.128 42.075 114.476 52.1326L88.7752 26.6115C101.977 11.3785 121.733 4.55816 141.227 12.028C151.688 16.0301 178.659 42.8189 182.692 53.2117C187.608 65.8675 186.368 80.9119 179.237 92.5096C159.313 115.946 135.87 136.354 114.476 158.491L114.465 158.502Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":219.65402221679688,\"m01\":1.1418701410293579,\"m02\":25.103998184204102,\"m10\":-0.89929437637329102,\"m11\":657.3430175781250,\"m12\":-242.97572326660156},\"opacity\":0.50,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint4_diamond_549_63577_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.167971 -0.000289537 0.00087322 0.211645 108.951 162.301)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 470.434,
    height: 242.578,
    fill: "url(#paint4_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 470.434,
    height: 242.578,
    transform: "scale(1 -1)",
    fill: "url(#paint4_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 470.434,
    height: 242.578,
    transform: "scale(-1 1)",
    fill: "url(#paint4_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 470.434,
    height: 242.578,
    transform: "scale(-1)",
    fill: "url(#paint4_diamond_549_63577)",
    opacity: 0.5,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M133.369 208.881C121.709 210.693 109.192 208.409 99.768 201.221L38.0092 139.808L37.4868 137.178L61.5697 113.204L115.879 167.408C129.106 178.2 149.02 159.12 146.617 145.037C146.053 141.705 142.626 140.207 144.026 137.189L168.088 113.194C182.663 125.715 189.246 143.266 183.698 162.158C179.372 176.901 148.905 206.471 133.369 208.881Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":335.94137573242188,\"m01\":1.7464405298233032,\"m02\":-59.892696380615234,\"m10\":-0.57907420396804810,\"m11\":423.28906250,\"m12\":-49.053672790527344},\"opacity\":0.50,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_549_63577",
    x: 0.740292,
    y: 0.949219,
    width: 367.609,
    height: 224.973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.20795
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.10398
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_549_63577"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_549_63577",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_549_63577",
    x: -14.9458,
    y: 8.98462,
    width: 242.725,
    height: 242.615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 21.063,
    dy: 21.063
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5315
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_549_63577"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_549_63577",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_diamond_549_63577_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9223 208.937C40.2473 210.784 28.5469 207.93 17.9703 199.296C-9.52678 176.875 -29.3776 149.345 -1.4499 117.293C15.5966 97.737 37.7896 80.3524 55.2142 60.859L57.1993 59.9567L81.9341 85.3254L24.9758 143.596C20.1549 159.06 43.7134 179.551 57.1993 166.467L81.9341 191.081C76.3674 199.684 64.0893 207.574 53.9223 208.937Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint2_diamond_549_63577_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.894 105.254L57.8773 52.6853C42.2645 36.944 13.8862 64.6089 28.3958 80.664L3.78938 105.254C-17.3184 89.157 -21.4895 61.9 -4.11158 41.2323C14.8213 18.7133 39.4067 -2.35178 69.7603 15.9416L135.5 79.9214L110.904 105.264L110.894 105.254Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint3_diamond_549_63577_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.465 158.502L89.878 133.117C96.9885 126.59 103.059 119.005 109.718 112.09C118.782 102.672 135.167 90.0476 142.267 80.8072C147.781 73.6307 148.652 66.9256 142.844 59.4348C136.112 50.7497 124.128 42.075 114.476 52.1326L88.7752 26.6115C101.977 11.3785 121.733 4.55816 141.227 12.028C151.688 16.0301 178.659 42.8189 182.692 53.2117C187.608 65.8675 186.368 80.9119 179.237 92.5096C159.313 115.946 135.87 136.354 114.476 158.491L114.465 158.502Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint4_diamond_549_63577_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.369 208.881C121.709 210.693 109.192 208.409 99.768 201.221L38.0092 139.808L37.4868 137.178L61.5697 113.204L115.879 167.408C129.106 178.2 149.02 159.12 146.617 145.037C146.053 141.705 142.626 140.207 144.026 137.189L168.088 113.194C182.663 125.715 189.246 143.266 183.698 162.158C179.372 176.901 148.905 206.471 133.369 208.881Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint5_diamond_549_63577_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3163 18.8484C42.5946 18.6811 43.6884 18.9396 44.677 19.7218C47.2475 21.7528 49.1031 24.2467 46.4924 27.1502C44.8989 28.9217 42.8243 30.4965 41.1955 32.2624L41.0099 32.3441L38.6978 30.0461L44.0222 24.7675C44.4728 23.3666 42.2706 21.5105 41.0099 22.6956L38.6978 20.466C39.2181 19.6866 40.3659 18.9719 41.3163 18.8484Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_549_63577",
    x: 33.687,
    y: 28.1904,
    width: 14.0591,
    height: 8.74854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_549_63577"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_549_63577",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint6_diamond_549_63577_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9864 28.1914L40.9407 32.9681C42.3997 34.3985 45.0516 31.8847 43.6957 30.4258L45.9951 28.1914C47.9676 29.6541 48.3574 32.1308 46.7334 34.0088C44.9642 36.055 42.6667 37.9692 39.8303 36.3069L33.687 30.4933L35.9855 28.1904L35.9864 28.1914Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_549_63577",
    x: 28.9419,
    y: 23.3657,
    width: 9.05615,
    height: 13.5637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_549_63577"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_549_63577",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint7_diamond_549_63577_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5966 23.3657L37.8951 25.6686C37.2304 26.2607 36.6629 26.9488 36.0404 27.576C35.1931 28.4304 33.6614 29.5757 32.9977 30.4139C32.4823 31.065 32.4008 31.6732 32.9437 32.3528C33.5731 33.1406 34.6933 33.9276 35.5956 33.0152L37.9982 35.3304C36.764 36.7123 34.9172 37.331 33.0949 36.6533C32.117 36.2903 29.5957 33.8601 29.2187 32.9173C28.7592 31.7692 28.8751 30.4044 29.5417 29.3523C31.4042 27.2263 33.5957 25.3749 35.5956 23.3667L35.5966 23.3657Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint8_diamond_549_63577_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8551 18.8473C34.9508 18.6828 36.127 18.89 37.0126 19.542L42.8162 25.1123L42.8653 25.3509L40.6022 27.5254L35.4987 22.609C34.2557 21.63 32.3843 23.3607 32.6102 24.6381C32.6632 24.9403 32.9852 25.0762 32.8536 25.3499L30.5925 27.5264C29.2229 26.3906 28.6043 24.7987 29.1257 23.0851C29.5321 21.7479 32.3951 19.0658 33.8551 18.8473Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_549_63577_clip_path",
    transform: "translate(-24.4059 -152.177)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.9419,
    y: 156.713,
    width: 310.79,
    height: 7.3212,
    rx: 3.6606
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_549_63577_clip_path",
    transform: "translate(-24.4059 -152.177)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.9419,
    y: 156.713,
    width: 96.39,
    height: 7.3212,
    rx: 3.6606
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_549_63577",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(150 92.5 -150 300 0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_diamond_549_63577",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_diamond_549_63577",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_diamond_549_63577",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_diamond_549_63577",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_diamond_549_63577",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_diamond_549_63577",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_diamond_549_63577",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_diamond_549_63577",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_549_63577",
    x1: 28.9419,
    y1: 160.374,
    x2: 125.332,
    y2: 160.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#084559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_549_63577",
    x1: 150,
    y1: 0,
    x2: 150,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_63577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 185,
    rx: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExample);
export default __webpack_public_path__ + "static/media/example.f3bf5063c671818ed67ba1b041efb6e9.svg";
export { ForwardRef as ReactComponent };